export const defaultAnnotations = {
    ConceptSchemesOrder: {Id: "ORDER", Type : "ORDER"},
    CategorySchemesOrder: {Id: "ORDER", Type : "ORDER"},
    LayoutCategorySchemesOrder: {Id: "ORDER", Type : "ORDER"},
    CodelistsOrder: {Id: "ORDER", Type : "ORDER"},
    CategorisationsOrder: {Id: "ORDER", Type : "ORDER"},
    LayoutRow: {Id: "LAYOUT_ROW", Type : "LAYOUT_ROW"},
    LayoutColumn: {Id: "LAYOUT_COLUMN", Type : "LAYOUT_COLUMN"},
    LayoutFilter: {Id: "LAYOUT_FILTER", Type : "LAYOUT_FILTER"},
    LayoutRowSection: {Id: "LAYOUT_ROW_SECTION", Type : "LAYOUT_ROW_SECTION"},
    //CARTESIAN
    LayoutChartPrimaryDimCartesian: {Id: "LAYOUT_CHART_PRIMARY_DIM_CARTESIAN", Type : "LAYOUT_CHART_PRIMARY_DIM_CARTESIAN"},
    LayoutChartSecondaryDimCartesian: {Id: "LAYOUT_CHART_SECONDARY_DIM_CARTESIAN", Type : "LAYOUT_CHART_SECONDARY_DIM_CARTESIAN"},
    LayoutChartFilterCartesian: {Id: "LAYOUT_CHART_FILTER_CARTESIAN", Type : "LAYOUT_CHART_FILTER_CARTESIAN"},
    LayoutChartLockedDimsCartesian: {Id: "LAYOUT_CHART_LOCKED_DIMS_CARTESIAN", Type : "LAYOUT_CHART_LOCKED_DIMS_CARTESIAN"},
    //RADIAL
    LayoutChartPrimaryDimRadial: {Id: "LAYOUT_CHART_PRIMARY_DIM_RADIAL", Type : "LAYOUT_CHART_PRIMARY_DIM_RADIAL"},
    LayoutChartSecondaryDimRadial: {Id: "LAYOUT_CHART_SECONDARY_DIM_RADIAL", Type : "LAYOUT_CHART_SECONDARY_DIM_RADIAL"},
    LayoutChartFilterRadial: {Id: "LAYOUT_CHART_FILTER_RADIAL", Type : "LAYOUT_CHART_FILTER_RADIAL"},
    LayoutChartLockedDimsRadial: {Id: "LAYOUT_CHART_LOCKED_DIMS_RADIAL", Type : "LAYOUT_CHART_LOCKED_DIMS_RADIAL"},
    NotDisplayed: {Id: "NOT_DISPLAYED", Type : "NOT_DISPLAYED"},
    LayoutDataflowKeywords: {Id: "KEYWORDS", Type : "KEYWORDS"},
    LayoutCriteriaSelection: {Id: "CRITERIA_SELECTION", Type : "CRITERIA_SELECTION"},
    LayoutAttachedDataFiles: {Id: "ATTACHED_DATA_FILES", Type : "ATTACHED_DATA_FILES"},
    LayoutDefaultPresentation: {Id: "DEFAULT_VIEW", Type : "DEFAULT_VIEW"},
    LayoutDecimalSeparator: {Id: "LAYOUT_DECIMAL_SEPARATOR", Type : "LAYOUT_DECIMAL_SEPARATOR"},
    LayoutNumberOfDecimals: {Id: "LAYOUT_NUMBER_OF_DECIMALS", Type : "LAYOUT_NUMBER_OF_DECIMALS"},
    LayoutReferenceMetadata: {Id: "METADATA_URL", Type : "METADATA_URL"},
    LayoutEmptyCellPlaceholder: {Id: "LAYOUT_EMPTY_CELL_PLACEHOLDER", Type : "LAYOUT_EMPTY_CELL_PLACEHOLDER"},
    LayoutDataflowNotes: {Id: "DATAFLOW_NOTES", Type : "DATAFLOW_NOTES"},
    LayoutTerritorialDimensionIds: {Id: "GEO_ID", Type : "GEO_ID"},
    LayoutDataflowSource: {Id: "DATAFLOW_SOURCE", Type : "DATAFLOW_SOURCE"},
    LayoutDataflowHidden: {Id: "DATAFLOW_HIDDEN", Type : "DATAFLOW_HIDDEN"},
    FullName: {Id: "FULL_NAME", Type: "FULL_NAME"},
    LayoutMapFilter: { Id: "LAYOUTMAPFILTER", Type: "LAYOUTMAPFILTER" },
    Default: {Id: "DEFAULT", Type : "DEFAULT", 
      TimePeriodStart: "TIME_PERIOD_START", TimePeriodEnd: "TIME_PERIOD_END",
      LastNObservation: "LASTNOBSERVATIONS", LastNPeriod: "LASTNPERIODS" },
    LinkedDataflowNode: {Id: "LINKEDDATAFLOWNODE", Type : "LINKEDDATAFLOWNODE"},
    DDBDataflow: {Id: "DDBDataflow", Type : "DDBDataflow"},
    CustomDSD: {Id: "CustomDSD", Type : "CustomDSD"},
    AssociatedCube: {Id: "AssociatedCube", Type : "AssociatedCube"},
    Changed: {Id: "CHANGED", Type : "CHANGED"},
    Metadataset: {Id: "AssociatedMetadataSet", Type : "AssociatedMetadataSet"},
    HaveMetadata: {Id: "HAVE_METADATA", Type : "HAVE_METADATA"},
    RestrictedForPublication: {Id: "RESTRICTED_FOR_PUBLICATION", Type : "RESTRICTED_FOR_PUBLICATION"},
    AttachedFilePath: {Id: "ATTACHED_FILE_PATH", Type : "ATTACHED_FILE_PATH"},
    DCAT_IsMultilingual: {Id: "SDMX21_IsMultilingual", Type : "SDMX21_IsMultilingual"},
    CustomIsPresentational: {Id: "CUSTOM_IS_PRESENTATIONAL", Type : "CUSTOM_IS_PRESENTATIONAL"},
    LastUpdate: {Id: "LAST_UPDATE", Type : "LAST_UPDATE"},
    DataflowCatalogType: {Id: "DATAFLOW_CATALOG_TYPE", Type : "DATAFLOW_CATALOG_TYPE"},
    TemporalDimOrder: {Id: "TEMPORAL_DIM_ORDER", Type : "TEMPORAL_DIM_ORDER"},
    DisabledViewers: {Id: "DISABLED_VIEWERS", Type : "DISABLED_VIEWERS"},
    TableLockedDims: {Id: "TABLE_LOCKED_DIMS", Type : "TABLE_LOCKED_DIMS"},
    HCLReference: {Id: "@SDMX", Type : "HIER_CONTEXT"},
    AnticipationExceedingMaxNumRecords: {Id: "ANITICIP_EXCEEDING_MAX_NUM_REC", Type : "ANITICIP_EXCEEDING_MAX_NUM_REC"},
    DDBContentConstraint: {Id: "DDB_CONTENT_CONSTRAINT", Type : "DDB_CONTENT_CONSTRAINT"},
    NonReadyForProduction: {Id: "NON_READY_FOR_PRODUCTION", Type : "NON_READY_FOR_PRODUCTION"},
    ReadyForProduction: {Id: "READY_FOR_PRODUCTION", Type : "READY_FOR_PRODUCTION"},
    AttributeAsDim : {Id: "ATTRIBUTE_AS_DIM", Type: "ATTRIBUTE_AS_DIM"},
    LayoutAggregateCells : {Id: "LAYOUT_AGGREGATE_CELLS", Type: "LAYOUT_AGGREGATE_CELLS"}
};